import { ActionIcon, CopyButton } from '@mantine/core';
import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon';

interface Props {
	value: string;
	dataTestId?: string;
}

export const CopyIconButton = ({ value, dataTestId }: Props) => (
	<CopyButton value={value} timeout={1500}>
		{({ copied, copy }) => (
			<ActionIcon
				variant="transparent"
				size="sm"
				c={copied ? 'teal.8' : 'dark.8'}
				onClick={(event) => {
					event.preventDefault();
					event.stopPropagation();
					copy();
				}}
				data-testid={dataTestId}
			>
				<Icon variant={copied ? 'checkmark' : 'copy'} size="md" />
			</ActionIcon>
		)}
	</CopyButton>
);
